/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type TeamsError = {
  errorType: TeamsErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type TeamsErrorType =
  | 'PORTAL_ID_REQUIRED'
  | 'PORTAL_ID_MISMATCH'
  | 'USER_ID_REQUIRED'
  | 'TEAMS_NOT_FOUND_FOR_PORTAL'
  | 'PRIMARY_SECONDARY_USER_OVERLAP'
  | 'PARENT_TEAMS_HUB_ID_MISMATCH'
  | 'TEAM_NAMES_ALREADY_EXIST'
  | 'MULTIPLE_HUB_IDS_SUPPLIED'
  | 'MISSING_PARENT_TEAM'
  | 'NO_PARENTLESS_TEAMS'
  | 'HIERARCHY_CYCLE'
  | 'USER_ON_SAME_TEAM_PRIMARY_SECONDARY'
  | 'TEAM_USERS_ALREADY_EXIST'
  | 'TEAM_NAME_EMPTY'
  | 'TEAM_IDS_NOT_FOUND'
  | 'USERS_ALREADY_BEING_UPDATED'
  | 'TEAM_CREATION_LIMIT_EXCEEDED'
  | 'ADVANCED_MODELING_NOT_SUPPORTED'
  | 'MULTITEAM_NOT_SUPPORTED'
  | 'SECONDARY_TEAMS_PER_USER_LIMIT_EXCEEDED'
  | 'INVALID_TEAM_USERS_FOR_DELETION'
  | 'MULTIPLE_HUB_IDS_IN_BULK_CREATE'
  | 'INVALID_TEAM_IDS_FOR_HUB'
  | 'USER_ON_MULTIPLE_PRIMARY_TEAMS'
  | 'TEAM_IDS_NOT_BELONG_TO_PORTAL'
  | 'SECONDARY_USER_MUST_HAVE_PRIMARY'
  | 'HUB_IDS_NOT_FOUND'
  | 'MISSING_TEAM_ROOT'
  | 'MULTIPLE_HUB_IDS_ON_ADVANCED_DELETE'
  | 'NO_MATCHING_TEAM_FOUND_FOR_ID'
  | 'TEAM_NOT_FOUND_IN_HIERARCHY'
  | 'UNSUPPORTED_LIMIT_ID'
  | 'TEAM_NAME_TOO_LONG'
  | 'INVALID_USER_IDS_FOR_HUB'
  | unhandledEnumCase;

export type AppFatTeamsUpdateRequest = { fatTeam: FatTeamUpdate };

export type AppTeamsBulkDeleteRequest = { teamIds: Default<number[]> };

export type AppTeamsCreateRequest = { fatTeamEgg: FatTeamEgg };

export type AppTeamsGetAccessibleByPortalUserRequest = {
  includeChildTeamMembers: Default<boolean>;
  includeHierarchy: Default<boolean>;
  userFilters: Default<UserFilters>;
};

export type AppTeamsGetByHubRequest = {
  includeHierarchy: Default<boolean>;
  userFilters: Default<UserFilters>;
};

export type AppTeamsGetByIdRequest = {
  teamId: number;
  userFilters: Default<UserFilters>;
};

export type AppTeamsGetByIdsRequest = {
  teamIds: Default<number[]>;
  userFilters: Default<UserFilters>;
};

export type AppTeamsSetUserTeamsStateRequest = {
  userId: number;
  portalUserTeamState: PortalUserTeamState;
};

export type AppTeamsUpdateParentsRequest = {
  teamIds: Default<number[]>;
  parentTeamId?: number;
};

/**
 *  Filters controlling which users are returned in team-membership responses.
 */
export type UserFilters = {
  includeHiddenUsers: Default<boolean>;
  includeManagedAgentUsers: Default<boolean>;
};

export type FatTeam = {
  portalId: number;
  childTeams: Default<FatTeam[]>;
  id: number;
  name: string;
  parentTeamId?: number;
  userIds: Default<number[]>;
  secondaryUserIds: Default<number[]>;
};

export type FatTeamEgg = {
  name: string;
  parentTeamId?: number;
  userIds: Default<number[]>;
  secondaryUserIds: Default<number[]>;
};

export type FatTeamResponse = { fatTeam: FatTeam };

export type FatTeamUpdate = {
  childTeams: Default<FatTeamUpdate[]>;
  id: number;
  name: string;
  parentTeamId?: number;
  userIds: Default<number[]>;
  secondaryUserIds: Default<number[]>;
};

export type FatTeamsResponse = { fatTeams: Default<FatTeam[]> };

export type MaybeFatTeamResponse = { fatTeam?: FatTeam };

export type PortalUserTeamState = {
  primaryTeamId?: number;
  secondaryTeamIds: Default<number[]>;
};

export type SetPortalUserTeamsStateResponse = {
  portalId: number;
  teamUsers: Default<TeamUser[]>;
};

export type TeamUser = {
  userId: number;
  teamId: number;
  primary: Default<boolean>;
};

export type GetByHubRequestType = Requestify<AppTeamsGetByHubRequest>;
export type GetByHubResponseType = FatTeamsResponse;
export type GetByHubErrorType = TeamsError & HubspotMetadata;
export const getByHubRpc: ChirpAvroRpcDetails<
  GetByHubRequestType,
  GetByHubResponseType,
  GetByHubErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getByHub',
  auth: 'app',
  fingerprint: 'FriHTTv_poQcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetByHubWithHierarchyResponseType = FatTeamsResponse;
export type GetByHubWithHierarchyErrorType = TeamsError & HubspotMetadata;
export const getByHubWithHierarchyRpc: ChirpAvroRpcDetails<
  undefined,
  GetByHubWithHierarchyResponseType,
  GetByHubWithHierarchyErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getByHubWithHierarchy',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAccessibleByPortalUserRequestType =
  Requestify<AppTeamsGetAccessibleByPortalUserRequest>;
export type GetAccessibleByPortalUserResponseType = FatTeamsResponse;
export type GetAccessibleByPortalUserErrorType = TeamsError & HubspotMetadata;
export const getAccessibleByPortalUserRpc: ChirpAvroRpcDetails<
  GetAccessibleByPortalUserRequestType,
  GetAccessibleByPortalUserResponseType,
  GetAccessibleByPortalUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getAccessibleByPortalUser',
  auth: 'app',
  fingerprint: 'rsk8uk0ewuscAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAccessibleByPortalUserUniqueResponseType = FatTeamsResponse;
export type GetAccessibleByPortalUserUniqueErrorType = TeamsError &
  HubspotMetadata;
export const getAccessibleByPortalUserUniqueRpc: ChirpAvroRpcDetails<
  undefined,
  GetAccessibleByPortalUserUniqueResponseType,
  GetAccessibleByPortalUserUniqueErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getAccessibleByPortalUserUnique',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetByIdRequestType = Requestify<AppTeamsGetByIdRequest>;
export type GetByIdResponseType = MaybeFatTeamResponse;
export type GetByIdErrorType = TeamsError & HubspotMetadata;
export const getByIdRpc: ChirpAvroRpcDetails<
  GetByIdRequestType,
  GetByIdResponseType,
  GetByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'IUUjZsLaqtxtq2s0XW_iO1RizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetByIdsRequestType = Requestify<AppTeamsGetByIdsRequest>;
export type GetByIdsResponseType = FatTeamsResponse;
export type GetByIdsErrorType = TeamsError & HubspotMetadata;
export const getByIdsRpc: ChirpAvroRpcDetails<
  GetByIdsRequestType,
  GetByIdsResponseType,
  GetByIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getByIds',
  auth: 'app',
  fingerprint: 'z4sSjSgxTbQcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateRequestType = Requestify<AppTeamsCreateRequest>;
export type CreateResponseType = FatTeamResponse;
export type CreateErrorType = TeamsError & HubspotMetadata;
export const createRpc: ChirpAvroRpcDetails<
  CreateRequestType,
  CreateResponseType,
  CreateErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'OdqFcXM-rEhKzw4pbD2TAFRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateFatTeamsRequestType = Requestify<AppFatTeamsUpdateRequest>;
export type UpdateFatTeamsResponseType = MaybeFatTeamResponse;
export type UpdateFatTeamsErrorType = TeamsError & HubspotMetadata;
export const updateFatTeamsRpc: ChirpAvroRpcDetails<
  UpdateFatTeamsRequestType,
  UpdateFatTeamsResponseType,
  UpdateFatTeamsErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'updateFatTeams',
  auth: 'app',
  fingerprint: '8HiwTIPJhAZtq2s0XW_iO1RizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateParentTeamsRequestType =
  Requestify<AppTeamsUpdateParentsRequest>;
export type UpdateParentTeamsResponseType = FatTeamsResponse;
export type UpdateParentTeamsErrorType = TeamsError & HubspotMetadata;
export const updateParentTeamsRpc: ChirpAvroRpcDetails<
  UpdateParentTeamsRequestType,
  UpdateParentTeamsResponseType,
  UpdateParentTeamsErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'updateParentTeams',
  auth: 'app',
  fingerprint: '3NQKdC-Luj8cAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteTeamsRequestType = Requestify<AppTeamsBulkDeleteRequest>;
export type DeleteTeamsResponseType = FatTeamsResponse;
export type DeleteTeamsErrorType = TeamsError & HubspotMetadata;
export const deleteTeamsRpc: ChirpAvroRpcDetails<
  DeleteTeamsRequestType,
  DeleteTeamsResponseType,
  DeleteTeamsErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'deleteTeams',
  auth: 'app',
  fingerprint: 'jnkPIBCqIWkcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetPortalUserTeamsStateRequestType =
  Requestify<AppTeamsSetUserTeamsStateRequest>;
export type SetPortalUserTeamsStateResponseType =
  SetPortalUserTeamsStateResponse;
export type SetPortalUserTeamsStateErrorType = TeamsError & HubspotMetadata;
export const setPortalUserTeamsStateRpc: ChirpAvroRpcDetails<
  SetPortalUserTeamsStateRequestType,
  SetPortalUserTeamsStateResponseType,
  SetPortalUserTeamsStateErrorType,
  false
> = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'setPortalUserTeamsState',
  auth: 'app',
  fingerprint: '9YYYNcTqqtRsX8rNP4cSOVRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
